import { combineReducers } from "redux";
import view from "./view";

const workshopReducer = combineReducers({
    view,
});

export default workshopReducer;
